import React, { Component, ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // Log error for monitoring service in production
    if (import.meta.env.PROD) {
      // You can send to error monitoring service like Sentry here
      console.error('Error Boundary caught an error:', error, errorInfo)
    } else {
      console.error('Error Boundary caught an error:', error, errorInfo)
    }
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback
      }

      return (
        <div className="min-h-screen bg-space-black flex items-center justify-center p-8">
          <div className="text-center space-y-6 max-w-md">
            <div className="text-6xl">🚀</div>
            <h1 className="text-2xl font-orbitron text-electric-cyan">
              Houston, we have a problem
            </h1>
            <p className="text-light-gray">
              Something went wrong in our constellation. The stars have misaligned temporarily.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="bg-electric-cyan text-space-black px-6 py-3 rounded-lg font-semibold hover:bg-electric-cyan/80 transition-colors"
            >
              Realign the Stars
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary